var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":("https://www.google.com/maps/embed/v1/place?key=" + _vm.apiKey + "&q=" + _vm.place),"frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }